import qs from 'qs';
import { AppConstants } from 'constants/index';
import { baseApi } from 'services/baseApi';
import {
  Permission as PermissionType, PermissionsParams, PermissionGroup as PermissionGroupType, PermissionGroupsParams,
} from 'app/resource/types/permission';
import { Meta } from 'types';
import _ from 'lodash';
import { cacheTags } from 'constants/cacheTags';

export const permission = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getResourcePermissions: builder.query<PermissionType[], PermissionsParams >({
      query: ({ skipGlobalLoading, ...params } = {}) => {
        const { Admin, Permission, Resource } = AppConstants.api;
        return {
          url: [Admin, Permission, Resource],
          meta: { skipGlobalLoading },
          params,
          paramsSerializer: (param) => qs.stringify(param),
        };
      },
    }),
    getResourcePermissionGroups: builder.query<PermissionGroupType[], PermissionGroupsParams>({
      query: ({ skipGlobalLoading, ...params }) => {
        const {
          Admin, PermissionGroup, Resource,
        } = AppConstants.api;
        return {
          url: [Admin, PermissionGroup, Resource],
          meta: { skipGlobalLoading },
          params,
        };
      },
      providesTags: [cacheTags.ResourcePermissionGroups],
    }),
    getResourceUsersPermissionResourcesNames: builder.query<string[], Meta>({
      query: ({ skipGlobalLoading } = {}) => {
        const {
          Admin, Resource,
        } = AppConstants.api;
        return {
          url: [Admin, Resource],
          meta: { skipGlobalLoading },
        };
      },
      transformResponse: (response: string[]) => _.sortBy(response),
    }),
    getResourceUserManagementPermissionResourcesNames: builder.query<string[], Meta>({
      query: ({ skipGlobalLoading } = {}) => {
        const {
          Admin, Resource, UserManagement,
        } = AppConstants.api;
        return {
          url: [Admin, Resource, UserManagement],
          meta: { skipGlobalLoading },
        };
      },
      transformResponse: (response: string[]) => _.sortBy(response),
    }),
  }),
});

export const {
  useLazyGetResourcePermissionsQuery, useGetResourcePermissionGroupsQuery, useLazyGetResourceUsersPermissionResourcesNamesQuery, useGetResourceUserManagementPermissionResourcesNamesQuery,
} = permission;
